import React, { Fragment, useContext, useState } from "react";
import { Card, CardText, Row, Col, CardBody } from "reactstrap";
import { Input, Icon, Button } from "semantic-ui-react";
import { GlobalContext } from "../../context/GlobalState";
import { Redirect } from "react-router-dom";
import OBLLogo from "../resources/logo_obl.png";
import { PublicAccessRepository } from "../../repositories";

export const CardNoData = () => {
  const { filterSearch, SearchParam, ResultsList, resultList } = useContext(GlobalContext);
  const [searchValue, setSearchValue] = useState("");

  async function busqueda() {
    if (searchValue !== "") {
      // let url = `${Services.PublicAccess.path}search?filter=${searchValue}`
      // let tracking = await Axios.get(url);
      const tracking = await PublicAccessRepository.getSearch(searchValue);

      // console.log(
      //   ":::==================================CARD NO DATA RESULTADOS!!!!!!!==========================================="
      // );
      // console.log(tracking.data.data);
      // console.log(
      //   "===> TUS DATOS CARD NO DATA: => ",
      //   tracking.data.data.length
      // );
      // console.log(
      //   "======================================================================================"
      // );

      if (tracking.data.length === 1) {
        ResultsList(tracking.data);
      } else {
        SearchParam(searchValue);
        setSearchValue("");
      }
    }
  }

  return (
    <Fragment>
      {resultList.length && resultList[0].ShipmentNumber ? (
        resultList.length > 1 ? (
          <Redirect to="/results" />
        ) : (
          <Redirect to={`/tracking/${resultList[0].ShipmentNumber}`} />
          // <Shipment />
        )
      ) : (
        ""
      )}
      <Card >
        <CardBody>
          <img
            src={OBLLogo}
            alt="OBL Logo"
            style={{ width: "25%", display: 'inline' }}
          />
          {" "}
          <b className="tag-custom-value-title">SHIPMENT TRACKING</b>
          <hr className="hr-style mt-2 mb-5" />
          <CardText>
            <CardBody>
              <Col xs="12">
                <p>
                  <b className="title-custom-value">No results were found with the reference: </b>"
                  <b> {filterSearch} </b> "
                </p>
              </Col>
              <br />
              {/* <Col sm="2"></Col> */}
              <Col xs="12">
                <p className="tag-custom-value">
                  Please check your entry or use a different reference. Be sure to enter the full reference, use a criteria from search suggestion we provide:
                </p>
                <br />
                <CardBody>
                  <ol className="tag-custom-value">
                    <li type="disc">Shipment No.</li>
                    <li type="disc">Customer ref.</li>
                    <li type="disc">Container No.</li>
                    <li type="disc">HBL/HAWB</li>
                  </ol>
                </CardBody>
              </Col>
              <Row className="d-flex align-items-center">
                <Col xs="12" md="3" lg="3">
                  <span className="title-custom-value">
                    Write your reference number:
                  </span>
                </Col>
                <Col xs="12" md="7" lg="7">
                  <Input
                    fluid
                    placeholder="Shipment No., Customer ref, Container No., HBL/HAWB"
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                  />
                </Col>
                <Col xs="12" md="2" lg="2">
                  <Button
                    fluid
                    color="blue"
                    // style={{ background: "#341043", color: "white" }}
                    onClick={() => {
                      busqueda();
                    }}
                  >
                    Track
                  </Button>
                </Col>
              </Row>
            </CardBody>
            <Col xs={12} className="mt-5">
              <Row className="d-flex align-items-center background-row" style={{ height: '70px' }}>
                <br />
                <Col sm="2" md="2" style={{
                  marginTop: "10px",
                }}>
                  <center>
                    <Icon
                      name="calendar alternate outline"
                      size="big"
                    />
                  </center>
                </Col>
                <Col sm="9">
                  <p>
                    Note: <br /> You can search for shipments made in the last 120 days.
                  </p>
                </Col>
              </Row>
            </Col>
          </CardText>
        </CardBody>
      </Card>
    </Fragment>
  );
};
